import { SheetManager } from "../../../../backend/src/common/taxform/SheetManager";
import Spec from "../../../../backend/src/common/specs/Spec";
import SpecFunction from "../../../../backend/src/common/specs/SpecFunction";
import SpecTernaryOperator from "../../../../backend/src/common/specs/SpecTernaryOperator";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["updateSpecManager"],
})
export class TaxFormBase extends Vue {
    @Prop({ default: null }) values: any; // values of the form
    @Prop({ default: null }) rules: any; // rules of the form
    @Prop({ default: null }) fieldsChild: any; // fields of the form
    @Prop({ default: null }) sheet: SheetManager; // cerfa of the form
    @Prop({ default: false }) isLoaded: boolean;
    @Prop({ default: "2023" }) millesimInput: string;
    @Prop({ default: false }) isSent: boolean;
    @Prop({ default: false }) readOnly: boolean;

    focusedFieldKey = "";

    dicoSelectorValues = {};

    get millesim(): string {
        const millesim: string = this.sheet?.millesim || this.millesimInput;
        if (!millesim) {
            console.warn("millesim not found");
            return "2024";
        }
        const currentYear: number = new Date().getFullYear();
        if (+millesim > currentYear) {
            return currentYear.toString();
        }
        return millesim;
    }

    get fieldsChild_(): { [key: string]: Spec | SpecFunction | SpecTernaryOperator } {
        // debugger
        if (this.fieldsChild && Object.keys(this.fieldsChild).length) {
            return this.fieldsChild;
        }
        return this?.sheet?.fields || {};
    }

    get rules_() {
        if (this.sheet) {
            return this.sheet.rules;
        }
        return this.rules;
    }

    get values_() {
        if (this.sheet) {
            return this.sheet.values;
        }
        return this.values;
    }

    get formId() {
        if (this.sheet) {
            return this.sheet.formId;
        }
        return "";
    }

    setFocused(e, key) {
        const focusedKey = e ? key : null;
        this.setFocusedField(focusedKey);
    }

    setFocusedField(key) {
        this.focusedFieldKey = key;
    }

    isImpactedByRule(key) {
        if (!this.focusedFieldKey) {
            return false;
        }
        if (key === this.focusedFieldKey) {
            return true;
        }
        try {
            const impactedFields = this.fieldsChild_[this.focusedFieldKey].getImpacted();
            return impactedFields.includes(key);
        } catch (e) {
            return false;
        }
    }

    isReadonly(field) {
        // check if the field is readonly
        if (this.isSent) {
            return true;
        }
        if (this.readOnly) {
            return true;
        }
        const spec = this.fieldsChild_?.[field];
        if (spec?.readonly) {
            return spec.readonly;
        }
        let rule = this.rules_?.[field];
        if (!rule) {
            return false;
        }
        if (rule?.readonly) {
            return rule.readonly;
        }
        if (rule?.function) {
            return true;
        }
        let value = this.values_?.[field];
        if (value?.readonly) {
            return value.readonly;
        }
        return false;
    }

    isCheckbox(selectorValue) {
        // check if the field is a checkbox
        if (!selectorValue) {
            return false;
        }
        let selects = this.getSelectorValuesFile(selectorValue);
        if (selects?.length <= 2) {
            if (selects?.[1]?.text === "Case cochée") {
                return true;
            }
        }
        return false;
    }

    getRepeatedKey(key, index) {
        if (!index || index === 1) {
            return key;
        }
        return `${key}_${index.toString().padStart(2, "0")}`;
    }

    isSmallInput(col) {
        if (col.width < 10) {
            return true;
        }
        return false;
    }

    updateSpecManager() {
        this.$emit("updateSpecManager");
    }

    selectorOfKey(columnKey) {
        if (this.values_) {
            if (this.values_?.[columnKey]?.type === "selector") {
                let selector = this.values_[columnKey].subtype || this.values_[columnKey].selector;
                return selector;
            }
        }
        return null;
    }

    isFormattedText(clumnKey) {
        if (this.values_) {
            if (this.values_?.[clumnKey]?.type === "formattedText") {
                return true;
            }
        }
        return false;
    }

    isText(clumnKey) {
        if (this.values_) {
            if (this.values_?.[clumnKey]?.type === "text") {
                return true;
            }
        }
        return false;
    }

    isPercentage(clumnKey) {
        if (this.values_) {
            if (this.values_?.[clumnKey]?.type === "percentage") {
                return true;
            }
        }
        return false;
    }

    getSelectorValuesFile(selectorValue) {
        if (!selectorValue) {
            debugger;
            return [];
        }
        if (!this.dicoSelectorValues[selectorValue]) {
            try {
                this.dicoSelectorValues[selectorValue] = require(
                    `./selectors/${this.millesim}/${selectorValue}.json`,
                );
            } catch (error) {
                console.error(selectorValue, "not found in dicoSelectorValues");
                debugger;
                return [];
            }
        }
        return [{ text: "", value: "" }, ...this.dicoSelectorValues[selectorValue].values];
    }

    getRadicalComposition(radNumber) {
        if (this.sheet) {
            return this.sheet.getRadicalComposition(radNumber);
        }
        debugger;
        return [];
    }

    getRadicalList(radicals) {
        if (this.sheet) {
            return this.sheet.getRadicalList(radicals);
        }
        debugger;
        return [];
    }

    justifyInputRight(key_) {
        if (key_.includes("_@")) {
            return false;
        }
        const [key] = key_.split("_");
        const value = this.values_?.[key];
        if (this.sheet?.cerfaNumber.startsWith("2072SA2")) {
            return true;
        }
        if (value?.type && ["number", "quantity"].includes(value.type)) {
            return true;
        }
        return false;
        // return true
    }

    isUserValue(field) {
        const spec = this.fieldsChild_?.[field];
        if (spec?.readonly) {
            return spec.isUserValue;
        }
        return false;
    }
}
